module.exports = __webpack_public_path__ + "static/hero-9dca4da1d11547027543b2b9364aec21.png";